<template>
  <section class="c-section c-section--contact">
    <b-skeleton-wrapper :loading="contextLoading">
      <template #loading>
          <b-card>
            <div class="container-fluid p-0">
              <div style="height:400px">
                <div class="w-100 d-flex justify-content-center">
                  <b-skeleton-img no-aspect width="100%" height="300px"></b-skeleton-img>
                </div>
              </div>
            </div>
            <div class="container">
              <div style=""
            class="w-100 d-flex align-items-start align-items-lg-center
              justify-content-center flex-column flex-lg-row">
                <div class="w-100 mb-4">
                    <b-skeleton animation="wave" width="90%" type="input" class="mb-2"></b-skeleton>
                    <b-skeleton animation="wave" width="90%" type="input" class="mb-2"></b-skeleton>
                    <b-skeleton animation="wave" width="90%" type="input" class="mb-3"></b-skeleton>
                    <b-skeleton animation="wave" type="button"></b-skeleton>
                </div>
                <div class="w-100 d-flex justify-content-center mb-5 pb-3">
                  <b-skeleton-img no-aspect width="80%" height="300px">
                  </b-skeleton-img>
                </div>
              </div>
            </div>
          </b-card>
      </template>
      <div v-if="context.banner" class="c-banner-top">
        <img :src="context.banner.fondo" alt="" class="c-banner-top__background">
        <div class="c-banner-top__gradient"></div>
        <div class="container position-relative h-100">
          <figure class="c-banner-top__semiluna">
            <img
              src="@/assets/images/semiluna.png"
              alt=""
              class="w-100 of--contain d-none d-md-block"
            >
          </figure>
          <div class="c-banner-top__contain">
            <div data-aos="fade-up">
              <h2 class="white fs-50 w-black mb-0">
                {{context.post.post_title}}
              </h2>
              <div class="d-flex">
                <router-link to="/" class="c-banner-top__link">
                  Inicio
                </router-link>
                <span class="mx-1 white fs-16 w-medium">/</span>
                <p class="white fs-16 w-medium mb-0">
                  {{context.post.post_title}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="context.informacion" class="c-contact">
        <div class="container">
          <div class="row justify-content-center gy-5">
            <div data-aos="fade-right" class="col-12 col-lg-5">
              <div class="">
                <h2 class="sec-alt fs-16 w-sbold line-height mb-3">
                  {{context.informacion.subtitulo}}
                </h2>
                <h2 v-html="titulos.informacion" class="c-contact__title mb-4 me-lg-5 pe-lg-4">
                </h2>
                <div v-if="general.data.information">
                  <div
                    data-aos="fade-right"
                    :data-aos-delay="100 * (0 + 1)"
                    class="d-flex gap-3 align-items-center mb-5">
                    <figure class="c-contact__icon">
                      <img src="@/assets/images/phone.png" alt="" class="h-100 of--contain">
                    </figure>
                    <div>
                      <p class="sec-color fs-21 w-bold mb-1">
                        Teléfonos
                      </p>
                      <p class="sec-alt fs-18 w-sbold mb-0">
                        {{general.data.information.telephone}} / {{general.data.information.phone}}
                      </p>
                    </div>
                  </div>
                  <div
                    data-aos="fade-right"
                    :data-aos-delay="100 * (1 + 1)"
                    class="d-flex gap-3 align-items-center mb-5">
                    <figure class="c-contact__icon">
                      <img src="@/assets/images/mail.png" alt="" class="h-100 of--contain">
                    </figure>
                    <div>
                      <p class="sec-color fs-21 w-bold mb-0">
                        Email
                      </p>
                      <p class="sec-alt fs-18 w-sbold mb-0">
                        {{general.data.information.email}}
                      </p>
                    </div>
                  </div>
                  <div
                    data-aos="fade-right"
                    :data-aos-delay="100 * (2 + 1)"
                    class="d-flex gap-3 align-items-center">
                    <figure class="c-contact__icon">
                      <img src="@/assets/images/location.png" alt="" class="h-100 of--contain">
                    </figure>
                    <div>
                      <p class="sec-color fs-21 w-bold mb-0">
                        Dirección
                      </p>
                      <p class="sec-alt fs-18 w-sbold mb-0">
                        {{general.data.information.address}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-aos="fade-left" class="col-12 col-lg-7">
              <ContactForm></ContactForm>
            </div>
          </div>
        </div>
      </div>
      <div v-if="context.mapa" class="c-map">
        <div class="container">
          <div class="row justify-content-center gy-3 gy-lg-5">
            <div class="col-10 col-md-8 col-lg-6">
              <h2 class="text-center sec-alt fs-16 w-sbold line-height mb-3">
                {{context.mapa.subtitulo}}
              </h2>
              <h2 v-html="titulos.mapa" class="c-map__title">
              </h2>
            </div>
            <div v-if="general.data.information.mapa" class="col-12">
              <div v-html="general.data.information.mapa" class="c-map__map">
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      test: null,
      context: {},
      contextLoading: true,
      titulos: {
        informacion: '',
        mapa: '',
      },
    };
  },
  computed: {
    ...mapState(['general']),
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'contacto' });
  },
  components: {
    ContactForm: () => import(/* webpackChunkName: "contact-form" */'@/components/ContactForm.vue'),
  },
  watch: {
    contextLoading(state) {
      if (!state) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.context.post.content;
        this.titulos.informacion = tempDiv.getElementsByTagName('h2')[0].innerHTML;
        this.titulos.mapa = tempDiv.getElementsByTagName('h2')[1].innerHTML;
      }
    },
  },
};
</script>
